import React, { useEffect, useState } from "react";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import NumberFormat from "react-number-format";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import Illustration from "../../../../../partials/content/Illustration";
import { getIncomingPaymentByInvoice } from "../../../../../services/finance/incomingPayment";
import { formatDate } from "../../../../../utils/utils";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function InvoicePayments({ history, invoiceID = 0, createPayment = true }) {
  const { reload } = useGlobalData();
  const [payments, setPayments] = useState([]);
  const [totalPayment, setTotalPayment] = useState(0);
  useEffect(() => {
    if (invoiceID > 0) {
      getPaymentsData(invoiceID);
    }
  }, [invoiceID, reload]);

  const invoicePaymentDetailColumn = [
    {
      header: "Exchange Rate To Base Currency",
      field: "exchangeRate",
      type: "currency",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      {payments.length ? (
        <React.Fragment>
          <CustomDataTable
            data={payments}
            dataDetailColumns={invoicePaymentDetailColumn}
            onRefreshData={() => {
              getPaymentsData(invoiceID);
            }}
            columns={[
              {
                header: "A/R Payment ID",
                field: "incomingPaymentCode",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Payment Date",
                field: "paymentDate",
                body: (rowData) => formatDate(rowData.paymentDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Cash Account",
                field: "glAccount.accountName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.glAccount.accountName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Payment Amount",
                field: "paymentAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.paymentAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Account Receivable Payment Detail">
                      <button
                        type="button"
                        onClick={() => {
                          history.push(
                            "/finance/incoming-payment-detail/" + rowData.ID
                          );
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Payment.png"
            guidance="You don't have any A/R Payments for this A/R invoice yet"
            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                history.push("/finance/payments/AR");
              }}
            >
              <i className="fas fa-map-marker-alt"></i>
              Go To A/R Payment
            </button>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );

  async function getPaymentsData(invoiceID) {
    const response = await getIncomingPaymentByInvoice(invoiceID);
    const { data } = response.data;
    const payments = data.incomingPayments;
    let totalPayment = 0;
    for (const payment of payments) {
      totalPayment += payment.paymentAmount;
    }
    setPayments(payments);
    setTotalPayment(totalPayment);
  }
}

export default InvoicePayments;
